define('modules/editor/behaviours/droppable',['require','exports','module','../models/editorstate'],function(require, exports, module){
	"use strict";
	var EditorState = require("../models/editorstate");
	var MoveState = EditorState.moveState;
  var GroupState = EditorState.groupState;


	/**
	 * Droppable jQuery events to be added to the view
	 * These are triggered from Movable views
	 * @type {Object}
	 */
	var DroppableEvents = {
		"lpg.dragover": "_onDroppableDragOver",
		"lpg.dragout": "_onDroppableDragOut",
		"lpg.drop": "_onDroppableDrop"
	};
	/**
	 * Droppable View Behaviour
	 * Used for views that accept Movable elements
	 * @type {Object}
	 */
	var Droppable = {
		/**
		 * Triggered when a Movable view is moved over this view
		 */
		_onDroppableDragOver: function(e){
      // avoid sections to response if area triggers
      e.stopPropagation();
			var movingView = MoveState.getMovingView();
			this.$el.addClass("noselect");
			if(!this.model.contains(movingView.model)){
				this.$el.addClass("drag-in-hover");
			}
			//monitor the Movable view position to update the visual aid
			this.listenTo(MoveState, "change:movingLastPos", _.throttle(this._updatePosBox, 250, {trailing: false}));
			//display the visual aid
			this.$(".ed-position-box").show();
		},
		/**
		 * Triggered when a Movable view is moved out of this view
		 */
		_onDroppableDragOut: function(){
			this.$el.removeClass("drag-in-hover");
			this.$el.removeClass("noselect");
			this.stopListening(MoveState, "change:movingLastPos");
			this._hidePosBox();
		},
    /**
     * Triggered when a Movable view is dropped inside this view
     * @param  {Event} e
     */
    _onDroppableDrop: function(e){
      e.stopPropagation();
      var lastPos = MoveState.getLastPosition(),
            offset = {
            left: this.$el.offset().left - this.$el.parents(".lpg-page").offset().left,
            top: this.$el.offset().top - this.$el.parents(".lpg-page").offset().top
          };
      
      this.stopListening(MoveState, "change:movingLastPos");
      GroupState.elements.each(function(movingItem){
        var movingView = movingItem.get("view"),
            element = movingView.model,
            currentPos = {
              x: parseInt(movingView.$el.css("left")),
              y: parseInt(movingView.$el.css("top"))
            };
        if (!this.model.contains(element)){
          //translate pos to this section coordinates
          currentPos.x = parseInt(movingItem.get("left") - offset.left);
          currentPos.y = parseInt(movingItem.get("top") - offset.top);

          this.data.moveElementToContainer(
            this.model,
            element,
            currentPos
           );
        } else {
          //just move in same container, store position in property group
          element.setPosition(currentPos);
          //this is needed since we have to set the same positions in several places
          movingItem.setRelativePosition(currentPos);
        }
        //EditorState.activeItemState.selectItem(element);
      }, this);
      EditorState.selectElement(GroupState.getFirstView());

      this.$el.removeClass("drag-in-hover");
      $(".js-page").removeClass("noselect");
      this._hidePosBox();
    },
		/**
		 * Updates the visual position box helper element
		 * @param  {Model} model
		 * @param  {object} lastPos
		 */
    _updatePosBox: function(model, lastPos){
      var sectionCoords = this.$el.offset(),
          pageCoords = this.$el.parents(".lpg-page").offset(),
          dY = sectionCoords.top - pageCoords.top,
          dX = sectionCoords.left - pageCoords.left,
          movingGroup = GroupState.getGroupDimensions();

      this.$(".ed-position-box").css({
        //width: movingView.$el.offset().left - this.$el.offset().left,
        //height: movingView.$el.offset().top - this.$el.offset().top
        width: movingGroup.left - dX,
        height: movingGroup.top - dY
      });
    },
		/**
		 * Hides the visual position box helper element
		 */
		_hidePosBox: function(){
			this.$(".ed-position-box").css({
				width: 0,
				height: 0
			})
			.hide();
		},

		mixed: function(klass, proto){
			proto.events = _.extend(proto.events || {}, DroppableEvents);
		}
	};
	module.exports = Droppable;
});

